<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <div class="slider">
    <div class="bkg">
      <img src="@/assets/img/ecommerce-storyline/bkg.webp" alt="Background">
      <div class="text-history"><div v-html="$t('ecommerceStoryline.vTitle')" /></div>
      <div class="img-base img-photo"><img src="@/assets/img/ecommerce-storyline/photo.webp" alt="Static photo"></div>

      <div class="label label-y label-photo"><p>{{ $t('ecommerceStoryline.photo.title') }}</p></div>
      <div class="label label-y label-photo-year"><p>2002</p></div>
      <PopoverPlate :x="591" :placement="stdPlacement" :title="$t('ecommerceStoryline.photo.title')">
        <p>{{ $t('ecommerceStoryline.photo.description') }}</p>
      </PopoverPlate>
      
      <div class="img-base img-carousel">
        <video autoplay muted loop="true" playsinline>
          <source src="@/assets/img/ecommerce-storyline/carousel.mp4" type="video/mp4">
          {{ $t('error.browserNoVideoTag') }}
        </video>
      </div>
      <div class="label label-y label-carousel"><p>{{ $t('ecommerceStoryline.carousel.title') }}</p></div>
      <div class="label label-y label-carousel-year"><p>2004</p></div>
      <PopoverPlate :x="1129" :placement="stdPlacement" :title="$t('ecommerceStoryline.carousel.title')">
        <p>{{ $t('ecommerceStoryline.carousel.description') }}</p>
      </PopoverPlate>
      
      <div class="img-base img-360">
        <video autoplay muted loop="true" playsinline>
          <source src="@/assets/img/ecommerce-storyline/360.mp4" type="video/mp4">
          {{ $t('error.browserNoVideoTag') }}
        </video>
      </div>
      <div class="label label-y label-360"><p v-html="$t('ecommerceStoryline.photo360.vTitle')" /></div>
      <div class="label label-y label-360-year"><p>2012</p></div>
      <PopoverPlate :x="1666" :placement="stdPlacement" :title="$t('ecommerceStoryline.photo360.title')">
        <p>{{ $t('ecommerceStoryline.photo360.description') }}</p>
      </PopoverPlate>

      
      <div class="img-base img-viewer-3d">
        <video autoplay muted loop="true" playsinline>
          <source src="@/assets/img/ecommerce-storyline/3d-viewer.mp4" type="video/mp4">
          {{ $t('error.browserNoVideoTag') }}
        </video>
      </div>
      <div class="label label-y label-3d-viewer label-light"><p v-html="$t('ecommerceStoryline.viewer3d.vTitle')" /></div>
      <div class="label label-y label-3d-viewer-year label-light"><p>2016</p></div>
      <PopoverPlate :x="2203" :placement="stdPlacement" :title="$t('ecommerceStoryline.viewer3d.title')">
        <p>{{ $t('ecommerceStoryline.viewer3d.description') }}</p>
      </PopoverPlate>
      
      <div class="img-base img-ar">
        <video autoplay muted loop="true" playsinline>
          <source src="@/assets/img/ecommerce-storyline/ar.mp4" type="video/mp4">
          {{ $t('error.browserNoVideoTag') }}
        </video>
      </div>
      <div class="label label-ar label-light"><p>{{ $t('ecommerceStoryline.ar.title') }}</p></div>
      <PopoverGroup>
        <PopoverPlate :x="2727" :placement="Placement.bottom" :title="$t('ecommerceStoryline.ar.titleExtended')">
          <p>{{ $t('ecommerceStoryline.ar.description') }}</p>
        </PopoverPlate>
        <PopoverPlate :x="2727" :y="215" :width="54" :height="54" :placement="Placement.right" 
          :title="$t('ecommerceStoryline.ar.qr.title')"
          >
          <template #image>
            <img class="absolute top-0" src="@/assets/img/ecommerce-storyline/qr-code-spring-chair.webp">
          </template>
          <p>{{ $t('ecommerceStoryline.ar.qr.cta') }}</p>
          <div style="width: 252px;" class="pt-6">
            <a :href="viewerUrl" target="_blank" :title="viewerLinkTitle">
              <qrcode-vue :size="252" level="H" :margin="0" class="w-full h-fit"
                :value="viewerUrl"
              />
            </a>
          </div>
          <p class="mt-4 flex justify-center text-highlight"><a :href="viewerUrl" target="_blank">🔗 {{ $t('ecommerceStoryline.ar.qr.cta-link') }} 🔗</a></p>
        </PopoverPlate>
      </PopoverGroup>

      <div class="claim-container">
        <div class="logo">
          <a href="/" target="_blank" title="My AR Studio website">
            <img src="~/assets/img/logo-wt.svg">
          </a>
        </div>
        <div class="text">
          <p v-html="$t('ecommerceStoryline.vClaim')"/>
          <a href="/" target="_blank" title="My AR Studio website" >myarstudio.cloud</a>
        </div>
      </div>

    </div>
  </div>
</template>
<script setup lang="ts">
import QrcodeVue from 'qrcode.vue'
import PopoverPlate, {Placement} from '~/components/storyline/PopoverPlate.vue';
import { PopoverGroup } from '@headlessui/vue'

const i18n = useI18n()

definePageMeta({
  layout: "none",
});

const smallScreen = ref(false)
const stdPlacement = ref(Placement.bottom)

// TODO: add prop?
// const { $i18n } = useNuxtApp()
// $i18n.locale.value = 'de'


onMounted( ()=> {
  if(import.meta.client) {
    smallScreen.value = window.innerWidth <= 768
    stdPlacement.value = smallScreen.value ? Placement.bottom : Placement.top
  }
})

// TODO: duplicated component and page

// TODO: customize and localize
const viewerLinkTitle = 'Spring Chair 3D-AR Viewer'
const viewerUrl = 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/55c33d9f-6bee-507e-bcbc-bb03754a030e/default/f18af829-384e-52cc-9942-660c61ded0fd/index.html?x-qr=1&language=' + i18n.locale
</script>

<style scoped>
p {
  /* color: var(--color-darkgray); */
  color: #414244;
}
.slider {
  width: 100%;
  height: 596px;
  overflow-x: auto;
}
.bkg {
  height: 596px;
  width: 4030px;
  position: relative;
}
.text-history {
  position: absolute;
  top: 93px;
  left: 86px;
  width: 180px;
  height: 242px;
  display: flex;
  flex-direction: column-reverse;
}
.text-history >>> p {
  font-size: 25px;
  line-height: 1.2;
  font-weight: 400;
}
span.nobr {
  white-space: nowrap;
}
.label {
  font-size: 19px;
  font-weight: 700;
  position: absolute;
}
.label-light p {
  color: #c5c1bf;
}
.label-y {
  top: 386px;
}

.label-photo {
  left: 668px;
}
.label-photo-year {
  right: 3093px;
}
.img-base {
  position: absolute;
  top: 75px;
  width: 270px;
  height: 270px;
}
.img-photo {
  left: 668px;
}
.img-carousel {
  left: 1205px;
}
.label-carousel {
  left: 1205px;
}
.label-carousel-year {
  right: 2555px;
}
.img-360 {
  left: 1741px;
}
.label-360 {
  left: 1741px;
  line-height: 1;
}
.label-360-year {
  right: 2019px;
}
.img-viewer-3d {
  left: 2285px;
}
.label-3d-viewer {
  left: 2285px;
  line-height: 1;
}
.label-3d-viewer-year {
  right: 1475px;
}
.img-ar {
  width: 540px;
  height: 377px;
  left: 2838px;
  top: 76px;
}
.label-ar {
  top: 442px;
  left: 2760px;
}


.claim-container {
  position: absolute;
  left: 3469px;
  top: 0;
}
.claim-container .logo {
  position: absolute;
  top: 60px;
  left: 80px;
  width: 120px;
}
.claim-container .logo img {
  width: 100%;
  height: auto;
}
.claim-container .text {
  position: absolute;
  top: 230px;
  left: 95px;
  width: 410px;
}

.claim-container .text p {
  font-size: 37px;
  font-weight: 300;
  line-height: 1.2;
  @apply text-white;
}
.claim-container .text a {
  display: block;
  font-size: 16px;
  font-weight: 300;
  line-height: 1;
  @apply text-white hover:underline mt-4;
}

</style>
